import React, { useEffect, useState } from 'react';
import api from '../api';

const LIVE_REFRESH_MS = 30 * 1000;

// the score by period and the game's top players. Live: on top of the open panel. Final: the whole card.
export default function GameRecap({ sport, game, final, onClick }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let gone = false;
    const load = () => api.fetchGameRecap(sport, game.id, { home: game.home_abbrev, away: game.away_abbrev })
      .then((d) => { if (!gone && d) setData(d); })
      .catch(() => {});
    load();
    if (final) return () => { gone = true; };
    const id = setInterval(load, LIVE_REFRESH_MS);
    return () => { gone = true; clearInterval(id); };
  }, [sport, game.id, game.home_abbrev, game.away_abbrev, final]);

  if (!data) return null;
  const cells = { gridTemplateColumns: `minmax(0, 1fr) repeat(${data.cols.length}, minmax(0, ${data.cols.length > 5 ? 30 : 44}px)) 56px` };
  const rows = [['away', game.away_logo], ['home', game.home_logo]];
  const lead = final ? (data.home.total > data.away.total ? 'home' : data.away.total > data.home.total ? 'away' : null) : null;
  return (
    <div className={`game-recap${final ? ' final' : ''}${onClick ? ' clickable' : ''}`} onClick={onClick}>
      <div className="game-recap-row head" style={cells}>
        <span>{final ? 'Final' : ''}</span>
        {data.cols.map((c, i) => <i key={c} className={!final && i === data.now ? 'now' : ''}>{c}</i>)}
        <i>T</i>
      </div>
      {rows.map(([key, logo]) => (
        <div key={key} className={`game-recap-row${lead && lead !== key ? ' lose' : ''}`} style={cells}>
          <span>{final && logo && <img src={logo} alt="" />}<b>{data[key].abbrev || game[`${key}_abbrev`]}</b></span>
          {data.cols.map((c, i) => <i key={c} className={!final && i === data.now ? 'now' : ''}>{data[key].lines[i] ?? '–'}</i>)}
          <strong>{data[key].total}</strong>
        </div>
      ))}
      {data.players.length > 0 && (
        <div className="game-recap-players">
          {data.players.map((p) => <span key={p.name}><b>{p.name}</b> {p.line}</span>)}
        </div>
      )}
    </div>
  );
}
